var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgConsumibles = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90476 10.9474H20.0952L22 16.2105H2L3.90476 10.9474Z",
    fill: "#29B6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 12.5263C17.1334 12.5263 6.86623 12.5263 6.28575 12.5263C5.4967 12.5263 4.85718 12.9974 4.85718 13.5789C4.85718 14.1605 5.4967 14.6316 6.28575 14.6316C6.86623 14.6316 17.1334 14.6316 17.7143 14.6316C18.5034 14.6316 19.1429 14.1605 19.1429 13.5789C19.1429 12.9974 18.5034 12.5263 17.7143 12.5263Z",
    fill: "#01579B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H2V16.2105H22V22Z",
    fill: "#0288D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28575 13.5789V12.5263C6.28575 8.31579 4.85718 3.05263 4.85718 3.05263C4.85718 3.05263 6.76194 3.57895 7.71432 3.57895C9.61908 3.57895 10.0953 2 12 2C13.9048 2 14.381 3.57895 16.2857 3.57895C17.2381 3.57895 19.1429 3.05263 19.1429 3.05263C19.1429 3.05263 17.7143 7.26316 17.7143 12.5263V13.5789H6.28575Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8095 13.579V9.36843L14.8571 13.579H12.9523L11.9999 8.3158L11.0475 13.579H9.14279L8.19041 9.36843V13.579H6.28564V14.6316H17.7142V13.579H15.8095Z",
    fill: "#BDBDBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.3158H22V19.8947H2V18.3158Z",
    fill: "#0277BD"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConsumibles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Consumibles.a898af85.svg";
export { ForwardRef as ReactComponent };